import { ColumnDescription } from 'components/common/Table/types';
import { OutdoorCreativeListDataProvider } from './OutdoorCreativeListDataProvider';
import {
  commonColumnSetting,
  CreativeListCommonColumns
} from './CreativeListCommonColumnData';
import { renderColumn } from 'components/TableColumn/TableColumn';

export class LineMessageCreativeListDataProvider extends OutdoorCreativeListDataProvider {
  override getColumns(): ColumnDescription<any, any>[] {
    return [
      renderColumn(
        commonColumnSetting[CreativeListCommonColumns.NAME_ID],
        this.formatters.nameIdFormatter,
        this.formatters.nameIdHeaderFormatter
      ),
      renderColumn(
        commonColumnSetting[CreativeListCommonColumns.STATUS],
        this.formatters.stateFormatter
      ),
      renderColumn(
        commonColumnSetting[CreativeListCommonColumns.LIMITATION],
        this.formatters.limitationFormatter
      ),
      renderColumn(
        commonColumnSetting[CreativeListCommonColumns.EDITBTNS],
        this.formatters.floatingEditBtnsFormatter
      )
    ];
  }
}
